import { DataGridRef } from "devextreme-react/cjs/data-grid";
import { PopupRef } from "devextreme-react/cjs/popup";

export async function closePopup(ref: React.RefObject<PopupRef>) {
  if (ref.current) {
    ref.current.instance().hide();
  }
}

export async function openPopup(ref: React.RefObject<PopupRef>) {
  if (ref.current) {
    ref.current.instance().show();
  }
}

export async function reloadGrid(ref: React.RefObject<DataGridRef>) {
  await ref?.current?.instance().refresh();
}

export function getValue(ref: any) {
  return ref?.current?.instance().option("value");
}

export const onContentReadySortArrow = (dxGridRef: React.RefObject<DataGridRef>) => {
  const gridInstance = dxGridRef?.current?.instance;
  if (!gridInstance) return;

  const element = gridInstance().element().querySelector(".dx-sort") as HTMLElement;

  if (element) {
    element.style.marginTop = "35%";
  }
};
